import createRoute                    from '@widesk-ui/tools/createRoute';
import ProductPricingStockChangeModel from '@models/shop/ProductPricingStockChangeModel';

export default createRoute.table('/product_pricing_stock_changes', 'shop', 'ProductPricingStockChangeTable', ProductPricingStockChangeModel.localize('plural'));